import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Base } from '../Base';
import { elevationStyles } from './Elevation.styles';
import { elevationTheme } from './Elevation.stylex';
import { useStyles } from '../../hooks/useStyles';
export const Elevation = forwardRef(function Elevation(props, forwardedRef) {
    const { styles, sx, level, disabled, ...other } = props;
    const { combineStyles, globalStyles } = useStyles({
        name: 'Elevation',
        styles: [elevationStyles, styles],
    });
    return (_jsx(Base, { "aria-hidden": true, ...other, sx: [
            elevationTheme,
            globalStyles,
            combineStyles('host', level !== undefined && `host$level${level}`, disabled && 'host$disabled'),
            sx,
        ], ref: forwardedRef }));
});
